export default {
  setupPhotoCover: "Setup Cover Photo",
  description: "Image should be at least 4KB",
  error: "Unsupported file type...",
  uploadImage: "Upload Image",
  cancel: "cancel",
  submit: "submit",
};
